import React, { useEffect, useMemo, useState } from 'react';
import { useAuth, Request } from '../context';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../components/Loader';
import './EditProfile.css';

const EditProfile = () => {
  const { user, updateProfile } = useAuth();
  const navigate = useNavigate();

  const initial = useMemo(() => ({
    name: user?.name || '',
    email: user?.email || '',
    imageUrl: user?.image_url || '',
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  }), [user]);

  const [values, setValues] = useState(initial);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    setValues(initial);
  }, [initial]);

  const set = (k) => (e) => setValues(v => ({ ...v, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!values.name.trim() || !values.email.trim()) {
      setError('Please fill in name and email.');
      return;
    }
    if (values.newPassword) {
      if (values.newPassword !== values.confirmNewPassword) {
        setError('New password and confirmation do not match.');
        return;
      }
    }

    try {
      setSaving(true);
        const payload = await Request('/users/'+user.id, 'PUT', {
          id: user.id,
          name: values.name,
          email: values.email,
          image_url: values.imageUrl,
          password: values.newPassword,
          confirmPassword: values.confirmNewPassword
        });
        if (payload && typeof payload === 'object') {
            // Update auth context so Profile re-renders immediately
            updateProfile(payload);
        }

        setSuccess('Profile updated successfully.');
      // Redirect back to profile
      navigate('/account/profile');
    } catch (err) {
      setError(err.message || 'Failed to update profile.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="edit-profile">
      <header className="edit-profile__header">
        <h1 className="edit-profile__title">Edit Profile</h1>
        <p className="edit-profile__subtitle">Update your personal information and password</p>
      </header>

      <form className="edit-profile__form" onSubmit={onSubmit}>
        {error && <div className="edit-profile__alert edit-profile__alert--error">{error}</div>}
        {success && <div className="edit-profile__alert edit-profile__alert--success">{success}</div>}

        <label className="edit-profile__field">
          <span className="edit-profile__label">Name</span>
          <input
            className="edit-profile__input"
            type="text"
            value={values.name}
            onChange={set('name')}
            placeholder="Your name"
          />
        </label>

        <label className="edit-profile__field">
          <span className="edit-profile__label">Email</span>
          <input
            className="edit-profile__input"
            type="email"
            value={values.email}
            onChange={set('email')}
            placeholder="you@example.com"
          />
        </label>

        <label className="edit-profile__field">
          <span className="edit-profile__label">Profile Picture URL</span>
          <input
            className="edit-profile__input"
            type="text"
            value={values.imageUrl}
            onChange={set('imageUrl')}
            placeholder="https://example.com/photo.jpg"
          />
        </label>

        <fieldset className="edit-profile__fieldset">
          <legend className="edit-profile__legend">Change password (optional)</legend>

          {/*<label className="edit-profile__field">*/}
          {/*  <span className="edit-profile__label">Current password</span>*/}
          {/*  <input*/}
          {/*    className="edit-profile__input"*/}
          {/*    type="password"*/}
          {/*    value={values.currentPassword}*/}
          {/*    onChange={set('currentPassword')}*/}
          {/*    placeholder="Enter current password"*/}
          {/*  />*/}
          {/*</label>*/}

          <div className="edit-profile__row">
            <label className="edit-profile__field">
              <span className="edit-profile__label">New password</span>
              <input
                className="edit-profile__input"
                type="password"
                value={values.newPassword}
                onChange={set('newPassword')}
                placeholder="Minimum 6 characters"
              />
            </label>

            <label className="edit-profile__field">
              <span className="edit-profile__label">Confirm new password</span>
              <input
                className="edit-profile__input"
                type="password"
                value={values.confirmNewPassword}
                onChange={set('confirmNewPassword')}
                placeholder="Re-enter new password"
              />
            </label>
          </div>
        </fieldset>

        <div className="edit-profile__actions">
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? <Loader size="small" color="#fff" /> : 'Save changes'}
          </button>
          <Link to="/account/profile" className="btn btn-link">Cancel</Link>
        </div>
      </form>
    </div>
  );
};

export default EditProfile;
